import { Provider } from "components/licensingAgency/LicensingAgencyContext";
import { LicensingAgencyList } from "components/licensingAgency/LicensingAgencyList";
import React from "react";

export const LicensingAgencies = () => {
    return (
        <Provider>
            <LicensingAgencyList />
        </Provider>
    );
};
